import { Calendar } from "lucide-react";

const TimelineSeparator = ({ date, time }) => (
  <div className="flex items-center justify-center my-6">
    <div className="flex-1 border-t border-gray-200"></div>
    <div className="flex items-center gap-2 px-4 py-2 bg-gray-50 rounded-full text-sm text-gray-600">
      <Calendar className="w-4 h-4" />
      <span className="font-medium">{date}</span>
      <span className="text-gray-500">•</span>
      <span>{time}</span>
    </div>
    <div className="flex-1 border-t border-gray-200"></div>
  </div>
);

export default TimelineSeparator;
